import finplanPlanTypeDictionary from "./finplanPlanTypeDictionary.json";

const normalisePlanType = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLocaleLowerCase("en-GB");

const categoryByPlanType = new Map(
  Object.entries(finplanPlanTypeDictionary).map(([planType, category]) => [
    normalisePlanType(planType),
    category,
  ]),
);

export const mapFinplanPlanType = (value) => {
  const planType = String(value ?? "").trim().replace(/\s+/g, " ");
  if (!planType) return "";
  return categoryByPlanType.get(normalisePlanType(planType)) || planType;
};

export const getFinplanPlanType = (row = {}) =>
  [
    row.FinplanPlanType,
    row["Finplan Plan Type"],
    row.PlanType,
    row["Plan Type"],
    row.BusinessType,
    row["Business Type"],
  ]
    .map((value) => String(value ?? "").trim())
    .find(Boolean) || "";
